import { CLOUDFLARE_USE_TURNSTILE_IN_BOOKER } from "../constants";
import { HttpError } from "../http-error";
import logger from "../logger";

const TURNSTILE_SECRET_ID = process.env.CLOUDFLARE_TURNSTILE_SECRET;

export const INVALID_CLOUDFLARE_TOKEN_ERROR = "Invalid cloudflare token";

export async function checkCfTurnstileToken({ token, remoteIp }: { token?: string; remoteIp: string }) {
  if (!TURNSTILE_SECRET_ID || CLOUDFLARE_USE_TURNSTILE_IN_BOOKER !== "1" || !!process.env.NEXT_PUBLIC_IS_E2E) {
    return {
      success: true,
    };
  }

  if (process.env.NODE_ENV === "development") {
    return {
      success: true,
    };
  }

  if (!token) {
    throw new HttpError({ statusCode: 401, message: "No cloudflare token - please try again" });
  }

  try {
    const form = new URLSearchParams();
    form.append("secret", TURNSTILE_SECRET_ID);
    form.append("response", token);
    form.append("remoteip", remoteIp);

    const result = await fetch("https://challenges.cloudflare.com/turnstile/v0/siteverify", {
      method: "POST",
      body: form,
      signal: AbortSignal.timeout(10000),
    });

    const data = await result.json();

    if (!data.success) {
      throw new HttpError({ statusCode: 401, message: INVALID_CLOUDFLARE_TOKEN_ERROR });
    }

    return data;
  } catch (error) {
    if (error instanceof HttpError) {
      throw error;
    }
    logger.error("Cloudflare Turnstile verification request failed", { error });
    throw new HttpError({
      statusCode: 503,
      message: "Verification service temporarily unavailable - please try again",
    });
  }
}
